import React from 'react';

import { Section } from './EggRetrieval.styled';
import { Heading } from 'components/v2/Typography/Heading';
import { Row, Column } from 'styled/Grid';

import { DetailsOfRetrieval } from './DetailsOfRetrieval/DetailsOfRetrieval';
import { CultureResult } from './EggRetrieval.types';

export const EggRetrieval = ({ cultureResult }: { cultureResult: CultureResult }) => {
  return (
    <Section>
      <Heading tag="h4">Details of Outcome</Heading>

      <Row>
        <Column $mobile={12}>
          <DetailsOfRetrieval cultureResult={cultureResult} />
        </Column>
      </Row>
    </Section>
  );
};
